<template>
  <div>
    <navbar></navbar>
    <div class="row ml-0 mr-0" style="box-shadow: none; margin-top: 95px">
      <div class="col-3 pl-0 pr-0"></div>
      <div class="col-6 pl-0 pr-0">
        <div class="createWorkspaceTitle">Create Workspace</div>
        <div style="margin-top: 40px">
          <form style="margin-bottom: 12px" @submit.prevent="createWorkspace">
            <div style="margin-bottom: 28px">
              <div style="margin-bottom: 12px">Type</div>
              <div class="row ml-0 mr-0">
                <template v-for="(item, index) in userAllowedWorkspaces">
                  <div class="col-3 createWorkspaceType curves" :key="index" 
                  :style="
                    selectedWorkspace === item
                      ? 'background:#FFD939'
                      : ''"
                  :title="item==='Direct Investment' ? 'Also for Mentors and Advisors' : ''"
                  @click="workspaceMethods(item)"
                    >
                    <div style="font-size: 14px">{{item}}</div>
                      <i
                      v-if="item==='Direct Investment'"
                      class="fa fa-question-circle questionMarkCls"
                      aria-hidden="true"></i>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="['Direct Investment', 'General Partner'].includes(selectedWorkspace)">
              <div class="form-group" style="margin-bottom: 21px">
                <div class="label">Workspace Title</div>
                <input
                  type="text"
                  required
                  v-model="title"
                  class="form-control team-form"
                  placeholder="Workspace Title"
                />
              </div>
              <div class="row" style="margin-bottom: 21px">
                <div class="col-6">
                  <div class="label">Primary Sectors (optional)</div>
                  <multiselect
                    v-model="sectorValues"
                    :options="availableSectors"
                    :multiple="true"
                    :custom-label="customLabel"
                    placeholder="Sectors"
                    class="filtersMultiselectDropdown"
                  ></multiselect>
                </div>
                <div class="col-6">
                  <div class="label">Stages (optional)</div>
                  <multiselect
                    v-model="stageValues"
                    :options="availableStages"
                    :multiple="true"
                    :custom-label="customLabel"
                    placeholder="Stages"
                    class="filtersMultiselectDropdown"
                  ></multiselect>
                </div>
              </div>
              <div>
                <div style="margin-bottom: 15px">Check Size</div>
                <ejs-slider
                  id="default"
                  :min="min"
                  :max="max"
                  :step="step"
                  :ticks="ticks"
                  :tooltip="tooltip"
                  :mintyp="mintype"
                  :type="type"
                  :value="value"
                  cssClass="createWorkspaceSlider"
                  :change="sizeChange"
                  :renderingTicks="renderingTicks"
                  :tooltipChange="tooltipChange"
                ></ejs-slider>
              </div>
              <div
                class="col-xl edit-company-action-button-row"
                style="padding: 0px; margin-top: 30px"
              >
                <button
                  type="button"
                  class="todo-form-cancel-button btn-outline-secondary"
                  @click="handleCancel"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="todo-form-submit-button btn btn-primary"
                  :disabled="isSaving"
                >
                  Save
                  <b-spinner
                    v-if="isSaving"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </div>
            </div>
          </form>
          <LpCreateWorkspace
              v-if="selectedWorkspace === 'Limited Partner'"
              @switchWorkspace="switchWorkspace"
            ></LpCreateWorkspace>
            <SPVCreateWorkspace
              v-if="selectedWorkspace === 'SPV'"
              @switchWorkspace="switchWorkspace"
            >
            </SPVCreateWorkspace>
        </div>
      </div>
      <div class="col-3 pl-0 pr-0"></div>
    </div>
    
  </div>
  
</template>
<script>
import NavbarNew from "../Layout/NavbarNew";
import {
  formatCurrency,
  vals,
  formatNumber,
  formatNumberWithComma,
} from "./../../../util";
import VueSlider from "vue-slider-component";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import Multiselect from "vue-multiselect";
import "vue-slider-component/theme/default.css";
import SwitchNotification from "../../../pages/Dashboard/Components/SwitchNotification";
import LpCreateWorkspace from "./LpCreateWorkspace";
import SPVCreateWorkspace from './SPVCreateWorkspace.vue';

export default {
    components: {
    [NavbarNew.name]: NavbarNew,
    VueSlider,
    Multiselect,
        SPVCreateWorkspace,
    [LpCreateWorkspace.name]: LpCreateWorkspace,
    [SPVCreateWorkspace.name] : SPVCreateWorkspace
  },
  data() {
    return {
      showDialogModal: false,
      addForm:{},
      vals,
      sectorValues: [],
      stageValues: [],
      isSaving: false,
      title: "",
      selectedWorkspace: "Direct Investment",
      value: [500000, 4000000],
      userAllowedWorkspaces: [],
    };
  },

  computed: {
    ...mapGetters("user", ["currency", "user"]),
    ...mapGetters("accountPlans", ["plan"]),
    sortedSectors() {
      let sectorList = this.vals.sectorList;
      sectorList.sort((a, b) => a.localeCompare(b));
      return sectorList;
    },
    gpStyle() {
      if (this.plan.toLowerCase() != "pi") return "cursor:not-allowed";
      else if (
        this.plan.toLowerCase() == "pi" &&
        this.selectedWorkspace == "General Partner"
      )
        return "background:#FFD939";
      else if (this.plan.toLowerCase() == "pi") return "cursor:pointer";
    },
    lpStyle() {
      if (this.plan.toLowerCase() != "pi")
        return "border-radius: 0px 18px 18px 0px; cursor: not-allowed";
      else if (
        this.plan.toLowerCase() == "pi" &&
        this.selectedWorkspace == "Limited Partner"
      )
        return "border-radius: 0px 18px 18px 0px;background:#FFD939";
      else if (this.plan.toLowerCase() == "pi")
        return "border-radius: 0px 18px 18px 0px;cursor:pointer";
    },
    availableSectors() {
      return this.sortedSectors.filter(
        (opt) => this.sectorValues.indexOf(opt) === -1
      );
    },
    availableStages() {
      return this.vals.WORKSPACE_STAGES.filter(
        (opt) => this.stageValues.indexOf(opt) === -1
      );
    },
  },
  created() {
    this.type = "Range";
    this.mintype = "MinRange";
    this.step = 10000;
    this.tooltip = {
      placement: "Before",
      isVisible: true,
      format: "C2",
      showOn: "Hover",
    };
    this.ticks = {
      placement: "After",
      format: "C2",
      largeStep: 1000000,
      smallStep: 1000000,
      showSmallTicks: true,
    };
    this.min = 1000;
    this.max = 10000000;
    this.height = 8;
    this.dotWidth = "22";
    this.bgStyle = {
      backgroundColor: "#fff",
      boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)",
    };
    this.tooltipStyle = {
      backgroundColor: "#FFD939",
      borderColor: "#FFD939",
    };
    this.absorb = true;
    this.processStyle = {
      backgroundColor: "#FFD939",
    };
    this.marks = 10000;
    this.tooltipMerge = true;
    this.formatter = (value) =>
      `${this.formatCurrency(value, this.currency.ref, 0, true)}`;
  },
  mounted(){
    api.get(`/getUserWorkspaceTypes/${this.$route.params.account_id}`).then(res => {
      const currentWorkspaceTypes = res.data.success.workspaceTypes;
      currentWorkspaceTypes.sort(function compare( a, b ) {
        if ( a.pos < b.pos ){
          return -1;
        }
        if ( a.pos > b.pos ){
          return 1;
        }
        return 0;
      })
      const workspaceTypes = currentWorkspaceTypes.map((elem) => elem.name);
      this.userAllowedWorkspaces = workspaceTypes;
      this.selectedWorkspace = this.userAllowedWorkspaces[0];
      if(this.$route.query.workspace_type){
        this.setSelectedWorkspace(this.$route.query.workspace_type)
      }
      
    }).catch(err => {
      console.log("error getting current users workspaceTypes : ", err);
    })
  },
  methods: {
    setSelectedWorkspace(workspace_type){
      switch(workspace_type){
        case "Direct Investment": {
          this.selectedWorkspace = "Direct Investment";
          break;
        }
        case "General Partner" : {
          this.selectedWorkspace = "General Partner";
          break;
        }
        case "Limited Partner": {
          this.selectedWorkspace = "Limited Partner";
          break;
        }
        case "SPV":{
          this.selectedWorkspace = "SPV";
          break;
        }
        default:
          break;
      }
    },
    handleAddCarryReceipt(){
      this.showDialogModal=true
    },
    formatCurrency: formatCurrency,
    sizeChange(args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = args.value[0];
        max = args.value[1];
      }
      if (String(min) && String(max)) {
        this.value = [min, max];
      }
    },
    gpMethod() {
      // if (this.plan.toLowerCase() == "pi") {
        this.selectedWorkspace = "General Partner";
        document.body.className = "sidebar-mini createWorkspace pageMainScroll";
      // }
    },
    directMethod() {
      this.selectedWorkspace = "Direct Investment";
      document.body.className = "sidebar-mini createWorkspace pageMainScroll";
    },
    lpMethod() {
      // if (this.plan.toLowerCase() == "pi") {
        this.selectedWorkspace = "Limited Partner";
        document.body.className =
          "sidebar-mini createLpWorkspace pageMainScroll";
      // }
    },
    workspaceMethods(name){
      if(name === "General Partner"){
        this.gpMethod();
      }else if(name === "Direct Investment"){
        this.directMethod();
      }else if(name === "Limited Partner"){
        this.lpMethod();
      }else if(name === "SPV"){
        this.selectedWorkspace = "SPV"
      }
    },
    renderingTicks: function (args) {
      args.text = this.formatCurrency(args.value, this.currency.ref, 0, true);
    },
    tooltipChange: function (args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = formatNumberWithComma(args.value[0]);
        max = formatNumberWithComma(args.value[1]);
        // min = this.formatCurrency(args.value[0], this.currency.ref, 0, true);
        // max = this.formatCurrency(args.value[1], this.currency.ref, 0, true);
      }
      if (min && max) args.text = `$${min} - $${max}`;
    },
    customLabel(option) {
      return `${option}`;
    },
    handleCancel() {
      this.isSaving = false;
      this.$router.go(-1);
    },
    roundNumber(value) {
      if (value <= 10) return (value / 10).toFixed() * 10;
      else if (value > 10 && value <= 999) return (value / 100).toFixed() * 100;
      else if (value >= 1000) return (value / 100).toFixed() * 100;
    },
    switchWorkspace(item) {
      this.$notifyClear();
      this.$notify({ component: SwitchNotification, timeout: 8000 });
      let userProfile = this.$store.getters["user/user"];
      let payload = {
        id: item.account,
        _id: item.account,
        workspace_id: item.workspace_id,
        image: userProfile.image ? userProfile.image : "",
        firstName: userProfile.firstName ? userProfile.firstName : "",
        lastName: userProfile.lastName ? userProfile.lastName : "",
        email: userProfile.email ? userProfile.email : "",
      };
      let fiifi = JSON.parse(localStorage.fiifi).user;
      var defaultPayload = {
        workspace_title: item.workspace_title,
        workspace_type: item.workspace_type,
        workspace_id: item.workspace_id,
        sectors: item.sectors,
        stages: item.stages,
        targetCapitalToDeployPercent: item.targetCapitalToDeployPercent,
        feeAndExpenseLoadAssumptionPercent:
          item.feeAndExpenseLoadAssumptionPercent,
      };
      this.$store.commit("workspace/setDefaultPipeline", {
        payload: defaultPayload,
      });
      this.$store.commit("user/workspace_id", {
        workspace_id: item.workspace_id,
      });
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        if (item.workspace_id == fiifi.workspace_id) {
          let data = this.$store.getters["portfolio/portfolioData"];
          this.$notifyClear();
          if (data && data.length > 0) {
            let url;
              if(item && item.hasOwnProperty("workspace_type")){
                if(item.workspace_type == "Limited Partner"){
                  url = `/${payload._id}/${payload.workspace_id}/lpSummary`
                }else if(item,workspace_type == "SPV"){
                  url = `/${payload._id}/${payload.workspace_id}/spvsummary`
                }else{
                  url = `/${payload._id}/${payload.workspace_id}/dashboard/overview`
                }
              }
            this.$router.push(url).catch((err) => {});
            return;
          } else {
            if(item.workspace_type == "SPV"){
              this.$router.push(`/${payload._id}/${payload.workspace_id}/spvsummary`)
            }else{
              this.$router.push(
              `/${payload._id}/${payload.workspace_id}/portfolio`
              );
            }
            return;
          }
        }
      }
      this.$store
        .dispatch("workspacePlans/getWorkspacePlanFeatures", {
          workspace_id: item.workspace_id,
        })
        .then((plans) => {
          this.$store.dispatch("arbiter/start");
          this.$store.dispatch("portfolio/apiFetchPortfolio").then((data) => {
            if (data && data.length > 0) {
              let url;
              if(item && item.hasOwnProperty("workspace_type")){
                if(item.workspace_type == "Limited Partner"){
                  url = `/${payload._id}/${payload.workspace_id}/lpSummary`
                }else if(item,workspace_type == "SPV"){
                  url = `/${payload._id}/${payload.workspace_id}/spvsummary`
                }else{
                  url = `/${payload._id}/${payload.workspace_id}/dashboard/overview`
                }
              }
              this.$router.push(url).catch((err) => {});
            } else {
              this.$notifyClear();
              if(item.workspace_type == "SPV"){
                this.$router.push(`/${payload._id}/${payload.workspace_id}/spvsummary`)
                }else{
                  this.$router.push(
                  `/${payload._id}/${payload.workspace_id}/portfolio`
                  );
              }
            }
          });
        });
    },
    createWorkspace() {
      let self = this;
      this.isSaving = true;
      this.title = this.title.trim();
      if (this.title.length <= 0) {
        this.$toaster.error("Please provide valid Workspace title");
        this.isSaving = false;
        return;
      }
      let payload = {
        type: this.selectedWorkspace,
        title: this.title,
        workspace_type: this.selectedWorkspace,
        sectors: this.sectorValues,
        stages: this.stageValues,
        checkSizeMin:
          this.value.length >= 1 && this.value[0]
            ? this.roundNumber(this.value[0])
            : "",
        checkSizeMax:
          this.value.length >= 1 && this.value[1]
            ? this.roundNumber(this.value[1])
            : "",
      };
      this.$store
        .dispatch("workspace/apiPostworkspacesInst", payload)
        .then((user) => {
          if (user.success) {
            let payload = {
              account: user.success.account,
              workspace_id: user.success.workspace,
              workspace_title: this.title,
              workspace_type: this.selectedWorkspace,
              sectors: this.sectorValues,
              stages: this.stageValues,
            };
            self.switchWorkspace(payload);
            self.$store.dispatch("workspace/apiFetchworkspaces");
          } else {
            self.handleCancel();
          }
        })
        .catch((err) => {
          this.isSaving = false;
          this.$toaster.error("Fail to save the workspace.");
        });
    },
  },
  beforeCreate: function () {
    document.body.className = "sidebar-mini createWorkspace pageMainScroll";
  },
  destroyed: function () {
    document.body.className = "sidebar-mini pageMainScroll";
  },
};
</script>
<style>
.questionMarkCls {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 5px;
}

.createWorkspace .e-tooltip-wrap {
  top: 380px !important;
}

.createWorkspaceSlider .e-slider-track {
  background: #d6d6d6 0% 0% no-repeat padding-box;
  border-radius: 8px;
  height: 8px !important;
}

.createWorkspaceSlider .e-handle {
  border-radius: 50%;
  border: 0 !important;
  width: 20px !important;
  background: #ffffff 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  height: 20px !important;
  border: 2px solid #ffd939 !important;
}

.createWorkspaceSlider .e-range {
  background-color: #ffd939 !important;
  height: 8px !important;
}

.e-slider-tooltip.e-tooltip-wrap.e-popup {
  background-color: #ffd947;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  border: 0;
  border-radius: 8px;
  cursor: -webkit-grab;
  cursor: grab;
  opacity: 1;
}

.e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-inner {
  color: #ffd939 !important;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
}

.e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-outer.e-tip-bottom {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  border-bottom-color: #ffd939 !important;
}

.e-slider-tooltip.e-tooltip-wrap.e-popup .e-arrow-tip-outer.e-tip-bottom {
  border-top-color: #ffd939 !important;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
}

.e-slider-tooltip.e-tooltip-wrap.e-popup .e-tip-content {
  background-color: transparent;
  height: 16px;
  overflow: hidden;
  color: #000000;
  font-weight: 500;
  padding: 0 8px;
  text-align: center;
  top: calc(50% - 8px);
  width: 100%;
}

  .curves:first-child{
    border-radius: 18px 0px 0px 18px;
  }
  .curves:last-child{
    border-radius: 0px 18px 18px 0px;
  }

  .curves:only-child{
    border-radius: 18px;
  }

</style>
